import {
  IAdminInquiryDetails,
  IAdminInquiryDetailsDto,
  TAdminInquiryEntry,
} from '@interfaces/adminInquiries';
import { IAdminMedicationInquiryDetailsDto } from '@interfaces/adminMedications';
import { IAdminSupplementInquiryDetailsDto } from '@interfaces/adminSupplements';

export class AdminInquiryDetails implements IAdminInquiryDetails {
  adminMedicationInquiryDetailsDto: IAdminMedicationInquiryDetailsDto[];

  adminSupplementInquiryDetailsDto: IAdminSupplementInquiryDetailsDto[];

  id: number;

  inquiryItems: TAdminInquiryEntry[];

  inquiryStatusId: number | null;

  isSupplementary: boolean;

  name: string;

  organizationId: number | null;

  programCodeId: number | null;

  submittedOn: string | null;

  timeElapsed: string | null;

  constructor(dto: IAdminInquiryDetailsDto) {
    const data: IAdminInquiryDetailsDto =
      dto && typeof dto === 'object' ? dto : ({} as IAdminInquiryDetailsDto);
    this.id = data.id;
    this.name = data.name || '';
    this.inquiryStatusId = data.inquiryStatusId || null;
    this.organizationId = data.organizationId || null;
    this.programCodeId = data.programCodeId || null;
    this.submittedOn = data.submittedOn || null;
    this.timeElapsed = data.timeElapsed || null;
    this.adminMedicationInquiryDetailsDto = Array.isArray(data.adminMedicationInquiryDetailsDto)
      ? data.adminMedicationInquiryDetailsDto
      : [];
    this.adminSupplementInquiryDetailsDto = Array.isArray(data.adminSupplementInquiryDetailsDto)
      ? data.adminSupplementInquiryDetailsDto
      : [];
    this.isSupplementary = Boolean(this.adminSupplementInquiryDetailsDto.length);
    if (this.isSupplementary) {
      this.inquiryItems = this.adminSupplementInquiryDetailsDto.map(item => ({
        ...item,
        entryInquiryId: item.supplementInquiryId,
        isSupplementary: true,
      }));
    } else {
      this.inquiryItems = this.adminMedicationInquiryDetailsDto.map(item => ({
        ...item,
        entryInquiryId: item.medicationInquiryId,
        isMedication: true,
      }));
    }
  }
}
